/**
 * ============================================================
 * ALTENS — ARTICLE
 * ============================================================
 *
 * Gestion :
 * - progression de lecture
 * - FAQ des articles
 */

/**
 * ============================================================
 * READING PROGRESS
 * ============================================================
 */

const initReadingProgress = () => {
    const progressBar = document.querySelector("[data-reading-progress]");

    const article = document.querySelector(".single-article");

    if (!progressBar || !article) {
        return;
    }

    let ticking = false;

    const updateProgress = () => {
        const articleRect = article.getBoundingClientRect();

        const articleTop = window.scrollY + articleRect.top;

        const articleHeight = article.offsetHeight;

        const viewportHeight = window.innerHeight;

        const scrollableDistance = Math.max(articleHeight - viewportHeight, 1);

        const currentPosition = window.scrollY - articleTop;

        const progress = Math.min(Math.max(currentPosition / scrollableDistance, 0), 1);

        progressBar.style.transform = `scaleX(${progress})`;

        ticking = false;
    };

    const requestProgressUpdate = () => {
        if (ticking) {
            return;
        }

        window.requestAnimationFrame(updateProgress);

        ticking = true;
    };

    window.addEventListener("scroll", requestProgressUpdate, {
        passive: true,
    });

    window.addEventListener("resize", requestProgressUpdate);

    updateProgress();
};

/**
 * ============================================================
 * ARTICLE FAQ
 * ============================================================
 */

const initArticleFaq = () => {
    const faqs = document.querySelectorAll(".article-faq");

    if (!faqs.length) {
        return;
    }

    faqs.forEach((faq) => {
        const items = faq.querySelectorAll("[data-article-faq-item]");

        items.forEach((item) => {
            const button = item.querySelector("[data-article-faq-button]");

            if (!button) {
                return;
            }

            button.addEventListener("click", () => {
                const isOpen = item.classList.contains("is-open");

                /**
                 * Ferme toutes les questions
                 * de cette FAQ.
                 */

                items.forEach((otherItem) => {
                    otherItem.classList.remove("is-open");

                    const otherButton = otherItem.querySelector("[data-article-faq-button]");

                    if (otherButton) {
                        otherButton.setAttribute("aria-expanded", "false");
                    }
                });

                /**
                 * Ouvre la question cliquée
                 * si elle était fermée.
                 */

                if (!isOpen) {
                    item.classList.add("is-open");

                    button.setAttribute("aria-expanded", "true");
                }
            });
        });
    });
};

/**
 * ============================================================
 * INITIALISATION ARTICLE
 * ============================================================
 */

const initArticle = () => {
    initReadingProgress();
    initArticleFaq();
};

export default initArticle;
